// extracted by mini-css-extract-plugin
export default {"applications_search_form":"Search_applications_search_form__TfFHA"};